import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { FieldSet, FormHelp, Flex, LabeledControl, Label, Checkbox } from '@zillow/constellation';
import React from 'react';
import { useFormContext, useFormState } from 'react-hook-form';
import FieldTooltip from './FieldTooltip.js';

function CheckboxField(_ref) {
  var _proxyFormState$error;
  var config = _ref.config,
    description = _ref.description,
    disabled = _ref.disabled,
    label = _ref.label,
    name = _ref.name,
    _onChange = _ref.onChange,
    tooltip = _ref.tooltip;
  var form = useFormContext();
  var proxyFormState = useFormState();
  var error = proxyFormState === null || proxyFormState === void 0 || (_proxyFormState$error = proxyFormState.errors[name]) === null || _proxyFormState$error === void 0 ? void 0 : _proxyFormState$error.message;
  var field = form.register(name, config);
  return /*#__PURE__*/React.createElement(FieldSet, {
    description: /*#__PURE__*/React.createElement(FormHelp, {
      error: Boolean(error)
    }, error || description)
  }, /*#__PURE__*/React.createElement(Flex, {
    display: "flex",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(LabeledControl, {
    label: /*#__PURE__*/React.createElement(Label, null, label),
    control: /*#__PURE__*/React.createElement(Checkbox, _extends({}, field, {
      disabled: disabled,
      onChange: function onChange(e) {
        field.onChange(e);
        _onChange === null || _onChange === void 0 || _onChange(e);
      }
    }))
  }), tooltip && /*#__PURE__*/React.createElement(FieldTooltip, tooltip)));
}

export { CheckboxField as default };
